import { Link } from "react-router-dom";
import {
  Sofa,
  BedDouble,
  Building2,
  Store,
  Coffee,
  Paintbrush,
} from "lucide-react";
import SectionFadeIn from "@/components/SectionFadeIn";
import { getRouteState } from "@/lib/navigation";

const rooms = [
  { name: "Living Room", icon: Sofa, line: "Statement focal point" },
  { name: "Bedroom", icon: BedDouble, line: "Calm, immersive retreat" },
  { name: "Office", icon: Building2, line: "Branded or inspirational" },
  { name: "Retail Space", icon: Store, line: "Memorable customer experience" },
  { name: "Hospitality", icon: Coffee, line: "Ambience guests remember" },
  { name: "Creative Studio", icon: Paintbrush, line: "Walls that inspire work" },
];

export function MuralRoomGuide({ location }) {
  return (
    <section
      className="py-24 md:py-28 bg-brand-surface/30"
      data-testid="room-guide-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionFadeIn>
          <div className="max-w-lg">
            <p className="text-[11px] tracking-[0.25em] uppercase font-semibold text-brand-gold mb-3">
              Where It Lives
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight text-brand-text leading-tight">
              Every Room, Reimagined
            </h2>
            <p className="mt-3 text-[14px] text-brand-text-secondary leading-relaxed">
              A mural changes how a space feels. Pick where yours will go.
            </p>
          </div>
        </SectionFadeIn>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4">
          {rooms.map((r, i) => (
            <SectionFadeIn key={r.name} delay={i * 80}>
              <Link
                to="/collections/wall-murals"
                state={getRouteState(location)}
                className="group flex items-center gap-4 px-6 py-5 bg-brand-surface border border-brand-border hover:border-brand-gold/40 transition-[border-color,color,background-color] duration-400 rounded-sm"
                data-testid={`room-${r.name.toLowerCase().replace(/\s/g, "-")}`}
              >
                <r.icon
                  size={22}
                  strokeWidth={1.6}
                  className="text-brand-gold shrink-0 group-hover:scale-110 transition-transform duration-300"
                />
                <div className="min-w-0">
                  <span className="block text-[13px] font-medium text-brand-text group-hover:text-brand-gold transition-colors duration-300">
                    {r.name}
                  </span>
                  <span className="block text-[11px] text-brand-text-secondary mt-0.5 truncate">
                    {r.line}
                  </span>
                </div>
              </Link>
            </SectionFadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
